import { PropsWithChildren } from "react";
import { useReactiveVar } from "shared/providers/apollo/apollo.package";
import { sidebarExpandedVar } from "../../common/apollo/vars/sidebar.var";

import { Layout as SharedLayout, Main } from "shared/components/layout";
import { Topbar } from "../../components/topbar";
import { Sidebar } from "../../components/sidebar";

const Layout = ({ children }: PropsWithChildren) => {
  const expanded = useReactiveVar(sidebarExpandedVar);

  return (
    <SharedLayout expanded={expanded}>
      <Topbar />
      <Sidebar />

      <Main>{children}</Main>
    </SharedLayout>
  );
};

export default Layout;
